import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Loader } from '@/components/custom/loader';
import { ProjectsContext } from '../provider';
import { useSession } from '@/hooks/useSession';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/custom/empty-state';
import { ProjectTimeline, ProjectTimelineCreate, ProjectTimelineGroup, ProjectTimelineItem, ProjectTimelineText, ProjectTimelineVersion, ProjectWorkspaceSidebar } from '@/components/custom/project';

// Timeline de versões lúdica: mesma estrutura da versão corporativa
// (project-timeline.jsx), só recolorida — bolinha em laranja (mission) e
// fundo da coluna igual ao usado na faixa de estrelinhas do card de desafio
// (bg-mission-light = #FFECD8). A variante corporativa continua em
// ../projects-list.jsx.
export const ProjectsListPlayful = props => {
  const { t } = useTranslation();
  const { projectId } = props;
  const { session } = useSession();
  const id = session.user.id;
  const { loading, getProject, getProjectVersion, selectedProject, selectedProjectVersion } = useContext(ProjectsContext);
  const [ownProject, setOwnProject] = useState(true);
  const authorityLevel = useAuthorityLevel();

  function checkIfUserIsOnProjec(selectedProject, id) {
    return selectedProject?.users?.some(obj => obj.id === id);
  }

  useEffect(() => {
    if (projectId) {
      getProject(true, projectId);
    }
  }, [projectId]);

  useEffect(() => {
    if (selectedProject) {
      if (checkIfUserIsOnProjec(selectedProject, id) || authorityLevel !== 'student') {
        setOwnProject(true);
      } else {
        setOwnProject(false);
      }
    }
  }, [selectedProject, session]);

  return (
    ownProject && (
      <ProjectWorkspaceSidebar style={{ backgroundColor: 'var(--color-bg-amber-soft)' }}>
        {loading && <Loader />}

        {!loading && selectedProject && (
          <ProjectTimeline>
            {selectedProject['project-versions'].map((pv, index) => (
              <ProjectTimelineItem
                key={index}
                onClick={() => getProjectVersion(pv.id)}
                active={selectedProjectVersion && pv.id === selectedProjectVersion.id}
                className={selectedProjectVersion && pv.id === selectedProjectVersion.id ? 'bg-white' : undefined}
              >
                <ProjectTimelineVersion className="bg-mission text-white">V.{pv.version}</ProjectTimelineVersion>
                <ProjectTimelineGroup>
                  <ProjectTimelineText>
                    {t('projects.versionProject')} {pv.version}.0
                  </ProjectTimelineText>
                  <ProjectTimelineCreate>
                    {t('projects.createdAt')} {moment(pv.created_at).format(t('datesForm.formatDate'))}
                  </ProjectTimelineCreate>
                </ProjectTimelineGroup>
              </ProjectTimelineItem>
            ))}
            {selectedProject.approved && <ProjectTimelineItem approved>🎉 Projeto aprovado!</ProjectTimelineItem>}
          </ProjectTimeline>
        )}

        {!selectedProjectVersion && !loading && (
          <EmptyState
            type="data"
            variant="plain"
            title={t('emptyState.missingDataTitle')}
            text={authorityLevel === 'admin' ? t('emptyState.textNoDataYet') : t('emptyState.submittingNewVersionText')}
          />
        )}
      </ProjectWorkspaceSidebar>
    )
  );
};
